<template>
  <div>
    <div class="topbar__main">
      <div class="topbar__row1">
        <div class="topbar__left">
          <a-tooltip placement="bottom" :title="this.headers[0].phone">
            <a :href="getTelUrl(this.headers[0].phone)">
              <div
                :style="{
                  borderRight: '1px solid #686868',
                  paddingRight: '1em',
                }"
                class="topbar__phone"
              >
                <font-awesome-icon
                  icon="phone"
                  color="green"
                  class="fa-flip-horizontal"
                />

                <span :style="{ letterSpacing: '-0.1px' }" class="phone__span">
                  <a
                    :href="getTelUrl(this.headers[0].phone)"
                    :style="{ color: '#686868' }"
                  >
                    {{ this.headers[0].phone }}</a
                  ></span
                >
              </div>
            </a>
          </a-tooltip>

          <a-tooltip placement="bottom" :title="this.headers[0].email">
            <div>
              <a :href="getEmailUrl(this.headers[0].email)">
                <font-awesome-icon
                  icon="at"
                  :style="{
                    marginRight: '4px',
                    color: '#686868',
                    marginLeft: '12px',
                  }"
                />
                <span class="phone__span">
                  <a
                    :href="getEmailUrl(this.headers[0].email)"
                    :style="{ color: '#686868' }"
                  >
                    {{ this.headers[0].email }}</a
                  ></span
                >
              </a>
            </div>
          </a-tooltip>

          <div
            :style="{
              borderLeft: '1px solid #686868',
              paddingLeft: '1em',
            }"
          >
            <span class="phone__span" :style="{ cursor: 'auto' }">
              {{ this.headers[0].quote }}</span
            >
          </div>
        </div>

        <div class="topbar__right">
          <div :style="{ paddingRight: '0.5em' }">
            <a-tooltip placement="bottom" title="Blog">
              <a
                href="
            https://blog.khaanpin.com/"
                target="_blank"
                class="link"
              >
                <font-awesome-icon icon="blog" />
                <span class="topbar__rightSpan"> Blog</span>
              </a>
            </a-tooltip>
          </div>

          <a-tooltip placement="bottom" title="Feedback">
            <div
              :style="{
                borderLeft: '1px solid #686868',
                borderRight: '1px solid #686868',
                paddingLeft: '1.5em',
                paddingRight: '1.5em',
              }"
              @click="onFeedback()"
            >
              <font-awesome-icon icon="comment" />
              <span class="topbar__rightSpan"> Feedback </span>
            </div>
          </a-tooltip>
          <!-- 
          <a-tooltip placement="bottom" title="Rewards">
            <div
              :style="{ borderLeft: '1px solid #686868', paddingLeft: '1em' }"
            >
              <font-awesome-icon icon="medal" />
              <span class="topbar__rightSpan"> Rewards </span>
            </div>
          </a-tooltip> -->

          <a-tooltip placement="bottom" title="Cart">
            <a-badge :count="cartQuantity" size="small" class="cart__badge">
              <div @click="onCart">
                <font-awesome-icon icon="cart-plus" />

                <span class="topbar__rightSpan"> Cart </span>
              </div>
            </a-badge>
          </a-tooltip>

          <a-tooltip placement="bottom" title="Account">
            <div
              :style="{
                borderLeft: '1px solid #686868',
                paddingLeft: '1em',
                marginLeft: '1em',
              }"
              class="topbar__accountDisplay"
              @click="onMyAccount()"
            >
              <img
                :src="require('../../assets/svg/account.svg')"
                class="topbar__accountImage"
                @click="onMyAccount()"
              />
            </div>
          </a-tooltip>
        </div>
      </div>

      <div class="main">
        <div class="topbar__backgroundHolder">
          <div class="topbar__row2">
            <div class="topbar__logo">
              <img
                :src="require('../../assets/socials/logo1.png')"
                @click="onHome"
              />
              <div
                class="topbar__location"
                @mouseover="showLocation"
                @mouseleave="hideLocation"
              >
                <svg
                  width="20pt"
                  height="20pt"
                  viewBox="0 0 700 700"
                  fill="white"
                >
                  <path
                    d="m347 84c-91.129 0-165 73.871-165 165 0 85.285 52.406 169.13 155.63 251.71 5.4805 4.3789 13.262 4.3789 18.742 0 103.22-82.582 155.63-166.43 155.63-251.71 0-91.129-73.871-165-165-165zm0 90c-41.422 0-75 33.578-75 75s33.578 75 75 75 75-33.578 75-75-33.578-75-75-75z"
                    fill-rule="evenodd"
                  />
                </svg>

                <div class="header__loc">
                  <span> {{ this.menuBranch }} </span>
                  <!-- <font-awesome-icon icon="angle-down" /> -->

                  <font-awesome-icon
                    icon="angle-down"
                    :class="showLocationList ? 'fa-flip-vertical' : 'fa-flip'"
                  />
                </div>

                <div class="header__location" v-show="showLocationList">
                  <LocationList v-on:getBranchId="getBranchId($event)" />
                </div>

                <!-- <a-select
                  bordered="{false}"
                  :default-value="menuBranch"
                  style="width: 115px"
                  @change="handleLocationChange"
                >
                  <a-select-option bordered="{false}" value="1">
                    Kathmandu
                  </a-select-option>
                  <a-select-option bordered="{false}" value="2">
                    Pokhara
                  </a-select-option>
                </a-select> -->
                <!-- <div class="header__locationDropdown">
                  <span v-for="b in branch" :key="b.id"> {{ b.location }}</span>
                </div> -->
              </div>
            </div>
            <nav class="topbar__items">
              <div
                class="topbar__menus"
                v-for="menu in allMenus"
                :key="menu.index"
                @mouseover="
                  handleHover(menu.id, menu.name);
                  getMenuId(menu);
                "
                @mouseleave="handleIsLeave()"
                @click="
                  getRealMenuId(menu.id);
                  this.isOpen = false;
                "
              >
                <div
                  :class="
                    menu.id == clicked && isOpen
                      ? 'topbar__itemActive'
                      : 'topbar__item'
                  "
                  @click="
                    handleClick(menu.id);

                    getSubmenu(menu);
                  "
                >
                  <span :style="{ marginRight: '6px' }">{{ menu.name }} </span>
                  <div v-if="menu.name">
                    <font-awesome-icon icon="caret-down" />
                  </div>
                </div>
                <div class="sippy__megamenu">
                  <Transition name="fade">
                    <div v-if="isOpen">
                      <MegaMenu
                        :clicked="clicked"
                        :locationId="locationId"
                        :menu="menu"
                        v-on:onClose="onClose($event)"
                      />
                    </div>
                  </Transition>
                </div>
              </div>
            </nav>
            <div :style="{ display: 'flex', alignItems: 'center' }">
              <div class="topbar__loginStatus">
                <span
                  class="topbar__guest"
                  v-if="this.loggedIn || this.loggedInApp"
                  >{{ this.greeting }}, {{ this.loggedUser.first_name }}!</span
                >
                <span class="topbar__guest" v-else
                  >{{ this.greeting }}, Guest!</span
                >

                <div
                  class="topbar__login"
                  v-if="this.loggedIn || this.loggedInApp"
                  @click="onMyAccount"
                >
                  My Account
                </div>

                <div class="topbar__login" @click="onLogin" v-else>
                  Login / Register
                  <!-- {{ this.menuBranch }} -->
                </div>
              </div>
              <div @click="click = !click" :style="{ cursor: 'pointer' }">
                <img
                  :src="require('../../assets/svg/hamburger.svg')"
                  class="topbar__hamburger"
                  v-if="!click"
                />
                <img
                  :src="require('../../assets/svg/cross.svg')"
                  class="topbar__cross"
                  v-if="click"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>hello tesitng inside mega</div> -->

    <div class="sippy__tabmegamenu">
      <div v-if="click">
        <MobileMegaMenu v-on:onClose="onClose($event)" :menu="menu" />
      </div>
    </div>

    <div class="sippy__mobilemegamenu">
      <div v-if="click">
        <MobileMegaMenu v-on:onClose="onClose($event)" :menu="menu" />
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";

import { mapGetters, mapActions } from "vuex";
import { LocationId } from "../../services/storage.service";
import axios from "axios";

import MegaMenu from "../../components/MegaMenu/MegaMenu.vue";
import LocationList from "../../components/LocationList/LocationList.vue";

import MobileMegaMenu from "../../components/MegaMenu/MobileMegaMenu.vue";
import TabMegaMenu from "../../components/MegaMenu/TabMegaMenu.vue";

export default {
  name: "Header",
  components: {
    MegaMenu,
    MobileMegaMenu,
    TabMegaMenu,
    LocationList,
  },
  data() {
    return {
      isOpen: false,
      click: false,
      clicked: "",
      menu: "",
      headers: [],
      locationId: this.getLocationId(),
      // locationID: LocationId.getLocationId(),
      // location: null,
      greeting: null,
      cartQuantity: 0,
      // menuBranch: this.menuBranch
      test: null,
      branch: [],
      showLocationList: false,
      isShow: false,
    };
  },
  beforeCreate() {},

  created() {
    window.scrollTo(0, 0);

    this.getBranches();
    this.getTime();
    const quantity = this.cartItems.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
    this.cartQuantity = quantity;
  },

  computed: {
    ...mapGetters([
      "allMenus",
      "loggedUser",
      "loggedIn",
      "loggedInApp",
      "currentLocation",
      "cartItems",
      "menuBranch",
    ]),
  },

  watch: {
    menuBranch(val) {},
    currentLocation(val) {
      this.isShow = true;
      this.getHeaders();
      this.getMenuBranch();
    },

    // locationId() {
    //   this.getLocation();
    //   // alert("location id change bhayo");
    // },

    // location() {
    //   this.getLocation();
    //   // this.getHeaders();
    // },

    cartItems(val) {
      const quantity = val.reduce((acc, item) => acc + item.quantity, 0);
      this.cartQuantity = quantity;
    },
  },

  methods: {
    ...mapActions([
      "updateLocationId",
      "setLocation",
      "getMenuId",
      "getRealMenuId",
      "clearCart",
    ]),

    getBranchId(loc) {
      // alert(loc);
      if (`${loc}` == 1) {
        this.updateLocationId(1);
        this.$router.push("/ktm");
        this.clearCart();
        window.location.reload();
      } else if (`${loc}` == 2) {
        this.updateLocationId(2);
        this.$router.push("/pkr");
        this.clearCart();

        window.location.reload();
      }
    },
    onClose(data) {
      this.isOpen = data;
      this.click = false;
    },

    // getLocation() {
    //   // alert(this.locationId)
    //   if (LocationId.getLocationId() == 1) {
    //     // alert(this.locationId);
    //     this.location = "Kathmandu";
    //     // alert(this.location);
    //   } else if (this.locationId == 2) {
    //     this.location = "Pokhara";
    //   }
    // },

    handleClick(id) {
      this.clicked = id;
      this.isOpen = false;
    },

    getTelUrl(no) {
      return "tel:" + no;
    },
    getEmailUrl(email) {
      return "mailto:" + email;
    },
    handleHover(id, menu) {
      this.clicked = id;
      this.menu = menu;
      this.isOpen = true;
    },

    handleIsLeave() {
      this.isOpen = false;
    },

    handleOpen() {
      this.isOpen = true;
    },

    showLocation() {
      this.showLocationList = true;
    },

    hideLocation() {
      this.showLocationList = false;
    },

    handleMenu() {
      if (isOpen) {
        isOpen = false;
      }
    },

    getLocationId() {
      return JSON.parse(localStorage.getItem("LOCATION_ID"));
    },

    handleLocationChange: function (loc) {
      if (`${loc}` == 1) {
        this.updateLocationId(1);
        this.$router.push("/ktm");
        window.location.reload();
      } else if (`${loc}` == 2) {
        this.updateLocationId(2);
        this.$router.push("/pkr");
        window.location.reload();
      }
    },

    getTime() {
      const today = new Date();
      const curHr = today.getHours();
      if (curHr < 12) {
        this.greeting = "Good Morning";
      } else if (curHr < 18) {
        this.greeting = "Good Afternoon";
      } else {
        this.greeting = "Good Evening";
      }
    },

    onCart() {
      router.push("/p/order");
    },
    onLogin() {
      router.push("/p/login");
    },
    onHome() {
      router.push("/");
    },
    onMyAccount() {
      if (this.loggedIn || this.loggedInApp) {
        router.push("/p/profile");
      } else {
        router.push("/p/login");
      }
    },

    onFeedback() {
      if (this.loggedIn || this.loggedInApp) {
        router.push("/p/profile");
      } else {
        router.push("/p/login");
      }
    },

    getSubmenu(submenu) {
      if (LocationId.getLocationId() == 1) {
        router.push(`/ktm/c/${submenu.name}/${submenu.id}`);
      } else if (LocationId.getLocationId() == 2) {
        router.push(`/pkr/c/${submenu.name}/${submenu.id}`);
      }
    },

    getHeaders() {
      axios
        .post("https://deus.khaanpin.com/appapi/headers/", {
          loc_id: `${LocationId.getLocationId()}`,
        })
        .then((res) => {
          const obj = Object.assign({}, res.data.data);
          this.headers = obj;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMenuBranch() {
      axios
        .post("https://deus.khaanpin.com/appapi/menulist/", {
          loc_id: this.locationId || this.currentLocation,
        })
        .then((res) => {
          this.test = res.data.branch;
        });
    },

    getBranches() {
      axios.get("https://deus.khaanpin.com/appapi/branch/").then((res) => {
        this.branch = res.data.data;
      });
    },
  },

  mounted() {
    this.getHeaders();
    this.getMenuBranch();
  },

  props: {
    msg: String,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.cart__badge {
  /* position: absolute; */
  /* border: 1px solid black; */
  padding-right: 8px;
  padding-left: 4px;
}

.sippy__megamenu {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 80px;
  width: 100%;
}

.topbar__menus:hover .sippy__megamenu {
  visibility: visible;
  transition-delay: 0.1s;
}

.ant-select >>> .ant-select-focused .ant-select-selector,
.ant-select >>> .ant-select-selector:focus,
.ant-select >>> .ant-select-selector:active,
.ant-select >>> .ant-select-open .ant-select-selector {
  box-shadow: none !important;
  outline: none !important;
}

.ant-select >>> .ant-select-selection-selected-value {
  background-color: transparent;
}

.ant-select >>> .ant-select-selection {
  background-color: transparent;
  color: #ffffff;
  font-size: 12px;
  font-weight: bolder;
  outline: none;
  margin-right: 0.5px;
  border: none;
  outline: none !important;
}

.ant-select >>> .ant-select-selection:focus {
  outline: none !important;
}
.ant-select-selector {
  border-color: rgba(204, 204, 204, 0.5) !important;
  box-shadow: none !important;
}

.ant-select >>> .ant-select-arrow svg {
  fill: white;
}

.ant-select >>> .ant-select-enabled {
  background-color: #ed2027;
}

.topbar__accountDisplay {
  display: none;
}

.topbar__accountImage {
  height: 25px;
  margin-bottom: -15%;
  margin-top: 4%;
  margin-right: -15px;
  /* margin-top: 4%; */
}

.topbar__row1 {
  display: flex;
  justify-content: space-between;
  color: #686868;
  font-weight: 500;
  font-size: 15px;
  font-family: "Montserrat", sans-serif;
  margin: 10px;
  height: 20px;
}

.topbar__left,
.topbar__right {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border: 1px solid black; */
  margin-right: 8px;
}

.topbar__left > div,
.topbar__right > div {
  margin-right: 1em;
  cursor: pointer;
}

.topbar__left > div:hover,
.topbar__right > div:hover {
  /* color: black; */
  transition: 0.8s all;
  /* text-decoration: underline; */
  /* font-weight: bold; */
}

.main {
  position: relative;
}

.topbar__backgroundHolder {
  background-color: #ed2027;
}

.topbar__row2 {
  height: 80px;
  background-image: url(../../assets/background/footer.png);
  display: flex;
  align-items: center;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
  justify-content: space-between;
}

.topbar__logo {
  display: flex;
  align-items: center;
  flex: 2.5;
  /* border :1px solid black; */
}

.topbar__logo > img {
  height: 60px;
  margin-left: 8px;
  cursor: pointer;
}

.topbar__location {
  position: relative;
  width: 190px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  border: 1px solid rgb(248, 248, 248);
  border-radius: 30px;
  cursor: pointer;
}

.header__loc {
  /* border: 1px solid black; */
  margin: 0 10px;
  font-size: 13px;
  font-family: "Montserrat", sans-serif;
}

.header__loc > span {
  margin-right: 10px;
  min-width: 5vw;
  font-family: "Montserrat", sans-serif;
}

.header__location {
  position: absolute;
  z-index: 9999;
  top: 36px;
  width: 100%;
}

.header__locationDropdown > span {
  bottom: -25px;
}

.topbar__location > select {
  margin-right: 5px;
  font-size: 12px;
  font-weight: bolder;
  border: none;
  background-color: transparent;
  color: white;
  outline: none;
  background: #dd3300;
  border-radius: 20px;
  cursor: pointer;
  width: 5rem;
}

.topbar__items {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: "Roboto", sans-serif;
  /* font-weight: bolder; */
  text-transform: uppercase;
  letter-spacing: 0.8px;
  /* position: relative; */
  flex: 7.5;
  /* border: 1px solid black; */
  height: 80px;
}
.topbar__menus {
  height: 80px;
  /* text-align: center; */
  display: inline-flex;
  padding: 1rem;
  /* position: relative; */
  /* border: 1px solid black; */
}

.text {
  position: absolute;
  /* top: 0; */
  bottom: -12px;
  /* border: 1px solid black; */
  width: 100%;
  background-color: blue;
  overflow: hidden;
  /*  */
}

.test {
  display: absolute;
  left: 0;
  top: 0;
}

.topbar__item > span {
  margin-right: 6px;
}
.topbar__item {
  /* padding: 0 0.3rem; */
  display: flex;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* border: 1px solid black; */
  /* transition: 0.3s; */
}

.topbar__itemActive {
  /* padding:  0.5rem; */

  /* padding: 0 0.2rem; */
  /* padding-bottom: 1rem; */
  /* padding-bottom: 5px; */
  /* background-color: white; */
  /* color: red; */
  color: #c9c9c9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* border-bottom: 4px solid white; */
  /* font-weight: bolder; */
  font-size: 15px;
  /* text-decoration: underline; */
  transition: all 0.1s ease-out;
  /* border-bottom: 2px solid white; */
  /* padding: 10px; */
  /* padding-bottom: 10px; */
}

.topbar__loginStatus {
  display: flex;
  flex-direction: column;
  align-items: flex-end !important;
  margin: 20px 20px;
  /* border: 1px solid black; */
  align-items: center;
  flex: 2;
}

.topbar__guest {
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
  margin-bottom: 2%;
  letter-spacing: 0.8px;
}

.topbar__login {
  border: 1px solid white;
  font-size: 13px;
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
  margin-top: 2%;
  padding: 8px 10px;
  border-radius: 18px;
  letter-spacing: 1px;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0.1;
}

.topbar__item.active,
.topbar__item:hover {
  /* border-bottom: 2px solid white; */
  font-size: 15.8px;
}
/* .sippy__megamenu{
  position: absolute;
} */

.sippy__mobilemegamenu {
  position: absolute;
  z-index: 999;
  transition: all 0.8s ease;
  display: none;
}

.sippy__tabmegamenu {
  position: absolute;
  z-index: 999;
  transition: all 0.8s ease;
  /* right: 0%; */
  display: none;
}

.topbar__hamburger {
  height: 35px;
  width: 35px;

  display: none;
  margin-right: 18px;
}

.topbar__cross {
  height: 20px;
  width: 20px;

  display: none;
  margin-right: 12px;
}

.link {
  color: #686868;
}

.topbar__rightSpan {
  cursor: pointer;
}

@media only screen and (max-width: 1400px) {
  .topbar__hamburger {
    display: block;
  }
  .sippy__tabmegamenu {
    display: block;
  }
  .topbar__cross {
    display: block;
  }
  .topbar__items {
    /* border: 3px solid black; */
    display: none;
  }
}

@media only screen and (max-width: 602px) {
  .topbar__loginStatus {
    display: none;
  }
  .topbar__accountDisplay {
    display: block;
  }
}

/* @media only screen and (max-width: 1270px) {
}  */
@media only screen and (max-width: 550px) {
  .topbar__logo > img {
    height: 50px;
  }

  .sippy__tabmegamenu {
    display: none;
  }

  .sippy__mobilemegamenu {
    position: absolute;
    z-index: 999;
    transition: all 0.8s ease;
    display: block;
  }

  .ant-select >>> .ant-select-selection {
    background-color: transparent;
    color: #ffffff;
    font-size: 12px;
    font-weight: bolder;
    /* border: 1px solid black; */
    outline: none !important;
    border: none !important;
    margin-left: -12px;
    margin-right: 1px;
  }

  .ant-select >>> .ant-select-enabled:focus {
    outline: none;
  }

  .ant-select >>> .ant-select:focus {
    outline: none;
  }

  .ant-select >>> .ant-select-focused:focus {
    outline: none;
  }
  .ant-select >>> .ant-select-open:focused {
    outline: none;
  }
  .topbar__hamburger {
    margin-right: 10px;
  }

  /* .topbar__location {
      padding: 4px 4px;
    } */
}

@media only screen and (max-width: 1080px) {
  .topbar__rightSpan {
    display: none;
  }
  .link > span {
    display: none;
  }

  .phone__span {
    display: none;
  }
  .topbar__phone {
    display: flex;
    align-items: center;
  }
  .topbar__phone > p {
    font-size: 8px;
    font-weight: bolder;
  }
}

.handleLocationChange:first-child {
  outline: red;
  border: 1px solid red !important ;
}
</style>
